import Vue from "vue";
import VueRouter from "vue-router";
//import Page404 from "@/components/Page404";


Vue.use(VueRouter);  // 引用vue-router

export default new VueRouter({
    routes:[
        // {
        //     path:"*",
        //     component:Page404
        // }
    ]
})